module.exports = __webpack_public_path__ + "img/reader-blue.65f4cc90.svg";